/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Review_Session_NoteInputs */

const en_directory_detail_review_session_note = /** @type {(inputs: Directory_Detail_Review_Session_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session rating — not yet published`)
};

const zh_directory_detail_review_session_note = /** @type {(inputs: Directory_Detail_Review_Session_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会话评分 — 尚未发布`)
};

/**
* | output |
* | --- |
* | "Session rating — not yet published" |
*
* @param {Directory_Detail_Review_Session_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_review_session_note = /** @type {((inputs?: Directory_Detail_Review_Session_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Review_Session_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_review_session_note(inputs)
	return zh_directory_detail_review_session_note(inputs)
});
export { directory_detail_review_session_note as "directory.detail.review_session_note" }